/* eslint-disable @typescript-eslint/camelcase */
import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import FaqSection from '../../components/Faq/Faq';
import PageHeader from '../../components/PageHeader/PageHeader';
import Benefits from '../../components/Benefits/Benefits';
import Footer from '../../components/Footer/Footer';
import BookNowCard from '../../components/BookNowCard/BookNowCard';
import '../../components/FormField/Input.css';
import StateGuidelines from '../../components/StateGuidelines/StateGuidelines';
import EpassRequiredOverlay from '../../components/Overlays/EpassRequiredOverlay';
import { useMediaQuery } from 'react-responsive';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import EpassNotRequiredOverlay from '../../components/Overlays/EpassNotRequiredOverlay';
import '../EPassPage/EPassPage.css';
import '../../components/CabModifySearch/CabModifySearch.css';
import DataLoaderError from '../../../server/errors/DataLoaderError';
import { EnvironmentVariables } from '../../types';
import { getAppEnv } from '../../../config/env';
import EPassSearch from '../../components/EPassSearch/EPassSearch';
import EPassInfo from '../../components/EPassInfo/EPassInfo';
import { EPassPageData } from './EpassPageDataChecker';
import { trackEPassPageEvent } from '../../utils/omnitureTracking';
import { isWebView } from '../../utils/commonUtils';

// import templateData from './EPassData';
const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;

type EPassPageDataProp = {
  data: EPassPageData;
};

const EPassPage = ({ data }: EPassPageDataProp) => {
  useEffect(() => {
    const stateLinks = document.getElementsByClassName(`Statelinks`);
    for (let i = 0; i < stateLinks.length; i++) {
      const stateName = stateLinks[i]['id'];
      stateLinks[i].addEventListener(`click`, () =>
        trackEPassPageEvent(`Cabs_SEO_Epass_${stateName}_ePass_link_Click`)
      );
    }
    const knowMoreElements = document.getElementsByClassName('knowMore');
    const stateGuildeLinesElement = document.getElementById(
      'beforeStateGuidelines'
    );

    for (let i = 0; i < knowMoreElements.length; i++) {
      knowMoreElements &&
        knowMoreElements[i].addEventListener(`click`, () => {
          stateGuildeLinesElement &&
            stateGuildeLinesElement.scrollIntoView(true);
        });
    }

    const safetyGuidelinesElements = document.getElementsByClassName(
      'faqStateGuidelines'
    );
    for (let i = 0; i < safetyGuidelinesElements.length; i++) {
      safetyGuidelinesElements[i].addEventListener('click', () => {
        trackEPassPageEvent(`Cabs_SEO_Epass_FAQ_state_guidelines_link_Click`);
      });
    }
  }, []);

  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 768px)'
  });
  const redirectToCabsLandingPage = () => {
    let cabsLandingUrl;
    if (isWebView())
      cabsLandingUrl = `mmyt://react/?page=cabs&deeplink=true&tripType=OW&source=epass_assistance`;
    else {
      cabsLandingUrl = isMobileDevice
        ? `https://cabs.makemytrip.com?source=epass_assistance`
        : `https://www.makemytrip.com/cabs?source=epass_assistance`;
    }
    // alert(cabsLandingUrl);
    window.location = Object(cabsLandingUrl);
  };
  const redirectToCabsListingPage = (cabsListingUrl = listingUrl) => {
    // alert(cabsListingUrl);
    window.location = Object(`${cabsListingUrl}&source=epass_assistance`);
  };
  const [required, setRequired] = useState(false);
  const [notRequired, setNotRequired] = useState(false);
  const [listingUrl, setListingUrl] = useState('');
  const [carPrice, setCarPrice] = useState('10/Km');
  const [cabsFound, setCabsFound] = useState(true);
  const handleRequired = () => {
    setRequired(!required);
    if (!required) {
      const bodyElement = document.querySelector('body');
      bodyElement && bodyElement.classList.add('fixed');
    } else {
      const bodyElement = document.querySelector('body');
      bodyElement && bodyElement.classList.remove('fixed');
    }
  };
  const handleNotRequired = () => {
    setNotRequired(!notRequired);
    if (!notRequired) {
      const bodyElement = document.querySelector('body');
      bodyElement && bodyElement.classList.add('fixed');
    } else {
      const bodyElement = document.querySelector('body');
      bodyElement && bodyElement.classList.remove('fixed');
    }
  };
  const { templateData } = data;
  return (
    <>
      <div className="epass__wrap">
        <Helmet>
          <title>{templateData.metaTitle}</title>
          <meta name="description" content={templateData.metaDescription} />
          <meta name="keywords" content={templateData.metaKeywords} />
          <link rel="canonical" href={templateData.sampleUrl} />
        </Helmet>
        <div>
          <BreadCrumb
            breadcrumb={data.templateData.breadcrumb}
            visible={false}
          />
          <h1 style={{ display: 'none' }} className="ePassHeader">
            {templateData.h1Title}
          </h1>
        </div>
        {/*-- Header --*/}
        {/* {<div className="mob__header makeFlex hrtlCenter mobileShow">
          <span className="epass__sprite mob__header__back appendRight10"></span><span className="font16 darkGreyText">e-Pass Assistance</span>
        </div>
        } */}
        <EPassSearch
          isMobileDevice={isMobileDevice}
          handleNotRequired={handleNotRequired}
          handleRequired={handleRequired}
          setListingUrl={setListingUrl}
          setCarPrice={setCarPrice}
          setCabsFound={setCabsFound}
        />
        {/*-- /Top Section --*/}
        <div className="epass__main">
          <EPassInfo isMobileDevice={true} />
          <EPassInfo isMobileDevice={false} />
          <BookNowCard
            redirectToCabsPage={redirectToCabsLandingPage}
            isMobileDevice={isMobileDevice}
          />
          {/* 
                    <section className="epass__tracker dark__text section__bdr">
                        <p className="section__heading latoBlack">e-Pass Application Tracker</p>
                        <div className="epass__tracker__item">
                            <div className="rec">
                                <p className="epass__tracker__no latoBlack">1,11,23,123</p>
                                <p className="font16 blackText">Applications
                        <span className="latoBold"> Received</span>
                                </p>
                            </div>
                            <div className="pro">
                                <p className="epass__tracker__no latoBlack">1,23,123</p>
                                <p className="font16 blackText">Applications
                        <span className="latoBold"> Processed</span>
                                </p>
                            </div>
                            <div className="rej">
                                <p className="epass__tracker__no latoBlack">23,123</p>
                                <p className="font16 blackText">Applications
                         <span className="latoBold"> Rejected</span>
                                </p>
                            </div>
                        </div>
                    </section> */}
          <Benefits redirectToCabsPage={redirectToCabsLandingPage} />
          {/* <Reviews /> */}
          <section
            style={{ paddingBottom: '0px', borderBottom: 'none' }}
            className="state__wise__pass dark__text section__bdr"
          >
            <p className="section__heading latoBlack">
              State-wise e-Pass Application Links
            </p>
            <StateGuidelines html={data.stateGuidelines} />

            <div className="benifits__tile">
              <p className="customer__name latoBlack">
                Guidelines for Safe Travel
              </p>
              <p className="customer__review learn__more">
                Select Indian States and UT have enforced specific travel
                restrictions. Do check applicable rules before travelling.{' '}
                <a
                  href="https://www.makemytrip.com/promos/mysafety-state-guidelines.html"
                  target="_blank"
                  className="latoBlack blueText capText"
                >
                  Learn More
                </a>
              </p>
            </div>
          </section>
        </div>
        {required && (
          <React.Fragment>
            <EpassRequiredOverlay
              handleRequired={handleRequired}
              redirectToCabsPage={redirectToCabsListingPage}
              carPrice={carPrice}
            />
            <div className="overlay__backdrop" onClick={handleRequired}></div>
          </React.Fragment>
        )}
        {notRequired && (
          <React.Fragment>
            <EpassNotRequiredOverlay
              cabsFound={cabsFound}
              handleNotRequired={handleNotRequired}
              redirectToCabsPage={
                cabsFound
                  ? redirectToCabsListingPage
                  : redirectToCabsLandingPage
              }
            />
            <div
              className="overlay__backdrop"
              onClick={handleNotRequired}
            ></div>
          </React.Fragment>
        )}
        <section className="container visibilityAuto">
          <>
            <FaqSection
              // trackTemplateEvent={trackEPassPageEvent}
              data={templateData.faq}
              pageUrl={templateData.sampleUrl}
            />
          </>
        </section>

        <Footer template={data.templateData} />
      </div>
    </>
  );
};

EPassPage.fetchData = async (_, match, urlObj, gRPCClient) => {
  const urlString = `${DATA_LOADER_URL}/api/getStateGuidelines`;

  let responseData;
  const response = await fetch(urlString);
  const textResponse = await response.text();
  try {
    responseData = JSON.parse(textResponse);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new Error('JSON parse exception: ' + textResponse);
  }
  if (responseData.status !== 'SUCCESS') {
    // eslint-disable-next-line no-console
    console.error('url', urlString);
    throw new DataLoaderError(`Unable to fetch bus list`, responseData.error);
  }

  const pathArray = urlObj.path.split('/');
  const cacheKey =
    'HTML_STATIC_' + pathArray[pathArray.length - 1].toUpperCase();

  // needs to be  in  a separate file or done differently,
  const templateData = {
    metaTitle:
      'COVID ePass for Cabs to Travel Interstate in Lockdown- Government of India - MakeMyTrip',
    metaDescription:
      'Book Cab with ePass and check epass requirements for your route. Statewise ePass application link and guidelines by Government of India During Lockdown on travel by car, flight or travel by train. MakeMyTrip offers sanitized cabs booking for interstate travel with safety.',
    metaKeywords:
      'COVID ePass, Travel ePass, ePass, Travel pass, Interstate travel pass, Government of India covid e-Pass, Jammu and Kashmir covid e-pass , Punjab covid e-pass , Himachal Pradesh covid e-pass , Haryana covid e-pass , Delhi covid e-pass , Rajasthan covid e-pass , Uttar Pradesh covid e-pass , Uttarakhand covid e-pass , Madhya Pradesh covid e-pass , Chattisgarh covid e-pass , Gujarat covid e-pass , Maharashtra covid e-pass , Karnataka covid e-pass , Goa covid e-pass , Kerala covid e-pass , Tamil nadu covid e-pass , Andhra pr covid e-pass , Telangana covid e-pass , Orissa covid e-pass , Bihar covid e-pass , Jharkhand covid e-pass , West Bengal covid e-pass , Assam covid e-pass , Arunach Pradesh covid e-pass , Sikkim covid e-pass , Meghalaya covid e-pass , Mizoram covid e-pass , Nagaland covid e-pass',
    analytics: `var s=s_gi('mmtprod');
              s.pageName="seo:domestic cabs:ePass";
              s.channel="seo";
              s.server = window.location.hostname;
              s.prop24="domestic cabs";
              if(typeof(mboxLoadSCPlugin) != "undefined" ){
              mboxLoadSCPlugin(s);
              }
              var s_code=s.t();if(s_code)document.write(s_code);`,
    footerData: `<div class="footer">
          <div class="groupListWrapper makeFlex column">
            <ul class="mainGroupList">
              <li><a href="https://www.makemytrip.com/flights/">Flights</a></li>
              <li><a href="https://www.makemytrip.com/flights-hotels" title="Cheap flight plus hotel Deals">Flight+Hotel Deals</a></li>
              <li><a href="https://www.makemytrip.com/international-flights/">International Flights</a></li>
              <li><a href="https://www.makemytrip.com/hotels/">Hotels</a></li>
              <li><a href="https://www.makemytrip.com/hotels-international">International Hotels</a></li>
              <li><a href="https://www.makemytrip.com/holidays-india">Holidays in India</a></li>
              <li><a href="https://www.makemytrip.com/holidays-international">International Holidays</a></li>
              <li><a href="https://www.makemytrip.com/bus-tickets/">Bus</a></li>
              <li><a href="https://www.makemytrip.com/railways/">Rail</a></li>
              <li><a href="https://www.makemytrip.com/cabs/">Cabs</a></li>
              <li><a href="https://www.makemytrip.com/flights/airlines.html">Airlines</a></li>
              <li><a href="https://www.makemytrip.com/flights/cheap.html">Cheap Flights</a></li>
              <li><a href="https://www.makemytrip.com/flights/flight-status.html">Flight Status</a></li>
              <li><a href="https://www.makemytrip.com/flights/flight_cancellation.html">Flight Cancellation</a></li>
              <li><a rel="nofollow" href="http://www.makemytrip.com/offsites/mice.html">MICE</a></li>
              <li><a rel="nofollow" href="http://b2b.makemytrip.com/makemytrip/AffiliateLoginHome.do">B2B</a></li>   
              <li><a href="https://www.makemytrip.com/hotels/?ccde=ae">Book Hotels From UAE</a></li>  
              <li><a href="https://www.makemytrip.com/railways/corona-virus-insurance-policy.html">Corona Health Insurance Policy</a></li>
              <li class="contentBoxBtn"></li>
            </ul>
          </div>
          <div class="groupListWrapper makeFlex column ">
              <p class="groupTitle">MakeMyTrip</p>
              <ul class="mainGroupList">
                <li><a href="https://www.makemytrip.com/about-us/company_profile.php">About Us</a></li>
                <li><a href="http://investors.makemytrip.com">Investor Relations</a></li>
                <li><a href="https://www.makemytrip.com/about-us/testimonials.html">Testimonial</a></li>
                <li><a href="https://www.makemytrip.com/about-us/jobs.php">Careers</a></li>
                <li><a href="https://www.makemytrip.com/about-us/social_resp.php">Social Responsibility</a></li>
                <li><a rel="nofollow" href="http://www.oktatabyebye.com/">Travel Community</a></li>
                <li><a href="https://www.makemytrip.com/offsites/corporatetravel.html">Corporate Travel</a></li>
                <li><a href="https://www.makemytrip.com/travel-guide/">Travel Guide</a></li>
                <li><a href="http://www.makemytrip.com/blog">Promotions</a></li>
                <li><a title="Explore India" href="http://explore.makemytrip.com">Explore India</a></li>
                <li><a href="https://makemytrip.com/flights/udan-yojana-flight.html" title="Udan Yojana Flights">Udan scheme Flights</a></li>
                <li><a href="https://www.makemytrip.com/coupons/flights.html" title="Flight Offers">Flight Offers</a></li>
                <li><a title="MakeMyTrip Coupons" href="https://www.makemytrip.com/coupons/">MakeMyTrip Coupons</a></li>
                <li class="contentBoxBtn"></li>
              </ul>
            </div>
          <div class="groupListWrapper makeFlex column ">
            <p class="groupTitle">Cab Booking</p>
            <ul class="mainGroupList">
              <li><a rel="nofollow" href="http://makemytrip.custhelp.com/">FAQs</a></li>
              <li><a href="https://www.makemytrip.com/support/sitemap.html">Site Map</a></li>
              <li><a href="https://support.makemytrip.com/customer_complaint/new_complaint.aspx?pcode=Footer">Complaints</a></li>
              <li><a href="https://www.makemytrip.com/support/contact_us.html">Contact Us</a></li>
              <li><a href="https://www.makemytrip.com/legal/payment_security.html">Payment Security</a></li>
              <li><a href="https://www.makemytrip.com/legal/privacy_policy.html">Privacy Policy</a></li>
              <li><a href="https://www.makemytrip.com/legal/user_agreement.html">User Agreement</a></li>
              <li><a href="https://www.makemytrip.com/holidays-international/visa-information.html">Visa Information</a></li>
              <li><a href="https://www.makemytrip.com/flights/flight_cancellation.html">Flight Cancellation</a></li>
              <li><a href="https://www.makemytrip.com/support/branch-offices.php">Branch Offices</a></li>
              <li class="contentBoxBtn"></li>
            </ul>
          </div>
          <div class="groupListWrapper makeFlex column ">
            <p class="groupTitle">Cab Booking</p>
            <ul class="mainGroupList">
              <li><a href="https://www.makemytrip.com/car-rental/new-delhi-city-cabs.html">Delhi Cab Booking</a></li>         
              <li><a href="https://www.makemytrip.com/car-rental/mumbai-city-cabs.html">Mumbai Cab Booking</a></li>         
              <li><a href="https://www.makemytrip.com/car-rental/bangalore-city-cabs.html">Bangalore Cab Booking</a></li>         
              <li><a href="https://www.makemytrip.com/car-rental/jaipur-city-cabs.html">Jaipur Cab Booking</a></li>         
              <li><a href="https://www.makemytrip.com/car-rental/shimla-city-cabs.html">Shimla Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/amritsar-city-cabs.html">Amritsar Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/bhopal-city-cabs.html">Bhopal Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/indore-city-cabs.html">Indore Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/kanpur-city-cabs.html">Kanpur Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/jabalpur-city-cabs.html">Jabalpur Cab Booking</a></li>
              <li><a href="https://www.makemytrip.com/car-rental/udaipur-city-cabs.html">Udaipur Cab Booking</a></li>      
            </ul>  
          </div>
        </div>`,
    h1Title: 'ePass for Cabs in Lockdown',
    breadcrumb: [
      {
        displayString: 'Home',
        redirectionUrl: 'https://www.makemytrip.com/'
      },
      {
        displayString: 'Cabs',
        redirectionUrl: 'https://www.makemytrip.com/cabs/'
      },
      {
        displayString: ' COVID ePass',
        redirectionUrl: 'https://www.makemytrip.com/car-rental/covid-epass.html'
      }
    ],
    faq: [
      {
        question: `Why ePass is required?`,
        answer: `With the Union government relaxing the lockdown, various state governments have come-up with blueprints to ease the traffic curbs in an orderly way and have issued fresh guidelines to avail ePass for swift movement across the state borders. However, the restrictions for general movement in containment zone will still be in place and people found travelling without proper documents are likely to face stiff punishment.`
      },
      {
        question: `How to get online ePass for travel?`,
        answer: `The state-wise lockdown e-Passes for movement permission can be applied through the links shared above for state ePasses.\r\n<br/>\r\n
                A central government website by the National Informatics Centre <a target="_blank" href="https://serviceonline.gov.in/epass/#">https://serviceonline.gov.in/epass</a> is also developed to apply for e-passes for movement during lockdown. Currently, this framework is being used by limited number of states of India to provide e-Pass services during COVID-19 pandemic.`
      },
      {
        question: `Is ePass required for flight/air and train travel?`,
        answer: `<span style="font-weight:700">Update as of July 1st 2020:</span> Following the recent instalment of unlock 2.0 in India, domestic flights will continue to operate as before and travellers will need an ePass (state-wise links above) for inter-district and inter-state travel outside the containment zones in India. Read state-wise ePass rules carefully before travelling.\r\n<br/>\r\n
                However, if someone has to cross the state border to catch a flight or train, then Covid e-pass is not required as long as the person has a confirmed flight/train ticket.\r\n<br/>\r\n
                To know more on state guidelines please visit <a class="faqStateGuidelines" target="_blank" href="https://www.makemytrip.com/promos/mysafety-state-guidelines.html">https://www.makemytrip.com/promos/mysafety-state-guidelines.html</a>.`
      },
      {
        question: `Checklist before you apply for e-pass?`,
        answer: `1.&nbsp Any individual/group can apply for the movement pass using this framework.\r\n<br/>\r\n
                 2.&nbsp Fill in all the mandatory details carefully and submit.\r\n<br/>\r\n
                 3.&nbsp Keep the scanned copy of the requisite documents before applying.\r\n<br/>\r\n
                 4.&nbsp Please use an active mobile number to receive verification OTP.\r\n<br/>\r\n
                 5.&nbsp After successful submission of your application, an application reference number will get generated. Please note it to track the application status.\r\n<br/>\r\n
                 6.&nbsp The movement e-pass will contain your name, address, validity and a QR code.\r\n<br/>\r\n
                 7.&nbsp Keep a soft/hard copy of the e-pass while traveling and show it to the security personnel if asked.`
      },
      {
        question: `What are the documents required for covid epass?`,
        answer: `You need to have a recent passport size photograph, vehicle registration number and a valid government-issued ID like the Voter ID Card, Aadhar Card, PAN Card or Driving License.`
      },
      {
        question: `How to track your ePass application?`,
        answer: `1. Visit <a target="_blank" href="http://serviceonline.gov.in/epass/">http://serviceonline.gov.in/epass</a> and click on the tab ‘Track your Application’.\r\n<br/>\r\n
                 2. Please use the following details to track your application:\r\n<br/>\r\n
                 &nbsp&nbsp&nbsp&nbsp
                 i. &nbsp&nbsp&nbsp Application Reference Number\r\n<br/>\r\n
                 &nbsp&nbsp&nbsp&nbsp
                  ii. &nbsp&nbspApplication Submission Date\r\n<br/>\r\n
                  &nbsp&nbsp&nbsp&nbsp
                   iii.&nbsp Name of the Applicant\r\n<br/>\r\n
                   &nbsp&nbsp&nbsp&nbsp
                   iv.&nbsp ID Proof Number\r\n<br/>\r\n
                   &nbsp&nbsp&nbsp&nbsp
                    v. &nbsp&nbsp&nbspEstimated Date of Arrival at Destination\r\n<br/>\r\n
                 3. If your application is approved, you can also download your movement pass from the website.`
      },
      {
        question: `How will I get my e-Pass after application?`,
        answer: `If your application gets accepted, you will receive the Covid e-pass on your phone as well as email. You can also check for your e-pass on the Aarogya Setu app.`
      },
      {
        question: `What are the quarantine rules for states?`,
        answer: `To know more on state guidelines please visit <a target="_blank" class="faqStateGuidelines" href="https://www.makemytrip.com/promos/mysafety-state-guidelines.html">https://www.makemytrip.com/promos/mysafety-state-guidelines.html</a>.`
      }
    ],
    externalJs: '',
    sampleUrl: 'https://www.makemytrip.com/car-rental/covid-epass.html'
  };

  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    ...responseData,
    templateData: templateData
  };
};
export default EPassPage;
